import type { GradeKey, SweetSpotPointResult } from './types';

export const SWEET_SPOT_CSV_FILENAME = 'sweet-spot-results.csv';

export const SWEET_SPOT_CLASS_LABELS: Record<GradeKey, string> = {
  I: 'Ⅰ级',
  II: 'Ⅱ级',
  III: 'Ⅲ级',
  IV: 'Ⅳ级',
  V: 'Ⅴ级',
};

export const formatSweetSpotDepth = (value: number | null | undefined) =>
  typeof value === 'number' && Number.isFinite(value) ? value.toFixed(1) : '—';

export const formatSweetSpotScore = (value: number | null | undefined) =>
  typeof value === 'number' && Number.isFinite(value) ? value.toFixed(4) : '—';

export const formatSweetSpotClass = (grade: GradeKey | null | undefined) =>
  grade ? SWEET_SPOT_CLASS_LABELS[grade] : '—';

const escapeCsvCell = (value: string) =>
  /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

/** CSV 与页面结果表共用相同格式化函数，保证导出内容与可见表格一致。 */
export function buildSweetSpotCsv(results: SweetSpotPointResult[]): string {
  const rows = results.map((result) => [
    formatSweetSpotDepth(result.depth),
    formatSweetSpotScore(result.rq),
    formatSweetSpotScore(result.cq),
    formatSweetSpotScore(result.ssi),
    formatSweetSpotClass(result.grade),
  ]);

  return [
    ['depth', 'RQ', 'CQ', 'SSI', 'sweetSpotClass'],
    ...rows,
  ].map((row) => row.map(escapeCsvCell).join(',')).join('\r\n');
}

export function downloadSweetSpotCsv(results: SweetSpotPointResult[]) {
  const blob = new Blob(['\uFEFF', buildSweetSpotCsv(results)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = SWEET_SPOT_CSV_FILENAME;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
